// extracted by mini-css-extract-plugin
module.exports = {"question":"_1jZg4or","header":"_2Ob50i4","description":"ONtLOjz","questionNumber":"_37n9mRh"};